import React from 'react';
import { Form } from 'react-bootstrap';

interface Props {
  selectedValues?: string[];
  onChange: (values: string[]) => void;
  isInvalid?: boolean;
  isValid?: boolean;
}

const GROSSIST_GRUPPER = [
  { value: 'NG', label: 'NG' },
  { value: 'DLVRY', label: 'DLVRY' },
  { value: 'SERVISGROS', label: 'SERVISGROS' },
];

const GrossistGrupperPicker: React.FC<Props> = ({
  selectedValues = [],
  onChange,
  isInvalid,
  isValid,
}) => {
  const handleCheckboxChange = (value: string, checked: boolean) => {
    const updatedValues = checked
      ? [...selectedValues, value]
      : selectedValues.filter((v) => v !== value);
    onChange(updatedValues);
  };

  return (
    <div>
      {GROSSIST_GRUPPER.map((gruppe) => (
        <Form.Check
          key={gruppe.value}
          type="checkbox"
          id={`grossist-gruppe-${gruppe.value}`}
          label={gruppe.label}
          checked={selectedValues.includes(gruppe.value)}
          onChange={(e) => handleCheckboxChange(gruppe.value, e.target.checked)}
          isInvalid={isInvalid}
          isValid={isValid}
        />
      ))}
    </div>
  );
};

export default GrossistGrupperPicker;
